import PropTypes from 'prop-types';
import React from 'react';
import './BrandLogo.css';

const BRAND_SHAPE =
  'M8 66 L117 3 Q128 -3 128 9 V66 Q128 74 121 78 L65 110 Q59 114 59 122 V154 Q59 161 53 165 L9 190 Q0 195 0 185 V80 Q0 71 8 66Z';

/** Horizontal purple/navy mark + wordmark — matches landing BrandLogo. */
function BrandLogo({ className = '' }) {
  return (
    <svg
      className={`brand-logo ${className}`.trim()}
      viewBox="0 0 300 64"
      role="img"
      aria-label="IndicatorAI"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(0 1.2) scale(.22)">
        <path d={BRAND_SHAPE} className="brand-logo-purple" />
        <path d={BRAND_SHAPE} transform="translate(160 280) rotate(180)" className="brand-logo-navy" />
      </g>
      <text x="48" y="47" className="brand-logo-wordmark">
        Indicator<tspan className="brand-logo-purple">AI</tspan>
      </text>
    </svg>
  );
}

BrandLogo.propTypes = {
  className: PropTypes.string,
};

/** Stacked mark only — collapsed sidebar. */
export function BrandMark({ className = '' }) {
  return (
    <svg
      className={`brand-mark ${className}`.trim()}
      viewBox="0 0 128 195"
      role="img"
      aria-label="IndicatorAI"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d={BRAND_SHAPE} className="brand-logo-purple" />
      <path d={BRAND_SHAPE} transform="translate(160 280) rotate(180)" className="brand-logo-navy" />
    </svg>
  );
}

BrandMark.propTypes = {
  className: PropTypes.string,
};

export default BrandLogo;
